import * as React from 'react';
import * as Colors from '../../consts/variables';
import { __ } from '../../helpers/TranslationService';
import { ArrowLeftIcon } from '../Icons/ArrowLeftIcon';

const styles: Record<string, React.CSSProperties> = {
    icon: {
        marginTop: 5,
        textDecoration: 'none',
        position: 'relative',
        display: 'flex',
        marginBottom: 5,
    },
    svg: {
        marginTop: 2,
        fill: Colors.softBlue,
        marginLeft: 10,
    },
    backLinkWrapper: {
        color: Colors.softBlue,
        position: 'relative',
        marginLeft: 3,
        marginTop: 0,
        fontSize: 13,
        fontWeight: 'bold',
    },
};

export const BackLink = () => {
    return (
        <>
            <a
                style={styles.icon}
                onClick={() => window.history.back()}
                title={__('Go Back', 'dreamlines')}
            >
                <ArrowLeftIcon style={styles.svg} width={10} height={10} />
                <div style={styles.backLinkWrapper}>{__('Go Back', 'dreamlines')}</div>
            </a>
        </>
    );
};
